import { getAuth, updateProfile, updateEmail } from 'firebase/auth';
import { getFirestore, doc, updateDoc } from 'firebase/firestore';
import {
  getStorage,
  ref,
  uploadBytesResumable,
  getDownloadURL,
} from 'firebase/storage';

const auth = getAuth();
const db = getFirestore();
const storage = getStorage();

export const updateUserProfile = async (userData, selectedFile) => {
  const user = auth.currentUser; // Obtém o usuário autenticado atual

  if (!user) {
    throw new Error('Usuário não autenticado');
  }

  try {
    // Se houver um arquivo selecionado, faça o upload da imagem do perfil
    if (selectedFile) {
      // Verifica o tipo de arquivo
      const validTypes = ['image/jpeg', 'image/png'];
      if (!validTypes.includes(selectedFile.type)) {
        throw new Error(
          'Tipo de arquivo inválido. Apenas arquivos PNG e JPG são permitidos.'
        );
      }

      // Gera um nome único para o arquivo, usando o UID do usuário e um timestamp
      const fileName = `${user.uid}_${Date.now()}_${selectedFile.name}`;
      const storageRef = ref(
        storage,
        `profilePictures/${user.uid}/${fileName}`
      );

      // Faz o upload do arquivo para a subpasta do usuário no Firebase Storage
      const uploadTask = uploadBytesResumable(storageRef, selectedFile);

      const downloadURL = await new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          null,
          (error) => reject(error),
          () => getDownloadURL(uploadTask.snapshot.ref).then(resolve)
        );
      });

      // Atualiza o perfil do usuário com o novo nome e URL da foto
      await updateProfile(user, {
        displayName: userData.nome,
        photoURL: downloadURL,
      });

      // Atualiza o campo photoURL no userData para ser salvo no Firestore
      userData.photoURL = downloadURL;
    } else {
      // Atualiza apenas o nome e o photoURL existente no perfil do usuário
      await updateProfile(user, {
        displayName: userData.nome,
        photoURL: userData.photoURL,
      });
    }

    // Atualiza o e-mail do usuário, se for diferente do atual
    if (userData.email && userData.email !== user.email) {
      await updateEmail(user, userData.email);
    }

    // Atualiza os dados do usuário no Firestore
    const userRef = doc(db, 'users', user.uid);
    await updateDoc(userRef, userData);
  } catch (error) {
    console.error('Erro ao atualizar o perfil:', error);
    throw error;
  }
};
